<template>
  <div v-if="isActive && shouldRender" class="guide-overlay" :style="overlayStyle">
    <!-- 遮罩层 - 使用四个区域组成带镂空的遮罩 -->
    <div class="guide-backdrop" >
      <!-- 上遮罩 -->
      <div class="guide-backdrop-section top" :style="{ height: elementRect ? `${elementRect.top}px` : '0',    width: '100%' }"></div>
      
      <!-- 中左遮罩 -->
      <div class="guide-backdrop-section middle-left" 
           :style="{ 
             left: '0',
             top: elementRect ? `${elementRect.top}px` : '0',
             width: elementRect ? `${elementRect.left}px` : '0',
             height: elementRect ? `${elementRect.height}px` : '0'
           }" @click="onBackdropClick"></div>
      
      <!-- 中右遮罩 -->
      <div class="guide-backdrop-section middle-right" 
           :style="{ 
             left: elementRect ? `${elementRect.left + elementRect.width}px` : '0',
             top: elementRect ? `${elementRect.top}px` : '0',
             right: '0',
             height: elementRect ? `${elementRect.height}px` : '0'
           }" @click="onBackdropClick"></div>
      
      <!-- 下遮罩 -->
      <div class="guide-backdrop-section bottom" 
           :style="{ 
             width: '100%',
             top: elementRect ? `${elementRect.top + elementRect.height}px` : '0',
             height: elementRect ? `calc(100% - ${elementRect.top + elementRect.height}px)` : '100%'
           }" @click="onBackdropClick"></div>
    </div>
    
    <!-- 高亮边框 - 围绕镂空区域显示 -->
    <div 
      class="guide-highlight-border" 
      :style="highlightBorderStyle"
      @click.stop="handleHighlightClick"
      ref="highlight"
    ></div>
    
    <!-- 提示框 -->
    <div 
      class="guide-tooltip" 
      :style="tooltipStyle"
      :class="[ 'guide-tooltip--' + effectivePosition  ]"
      ref="tooltip"
    >
    <div  class="guide-tooltip-2">
      <div class="guide-tooltip__title">
        <span  v-if="currentStep.title">
          {{ currentStep.title }}
        </span>
        <div @click="finish">关闭</div>
      </div>
      <div class="guide-tooltip__content">
        <div class="guide-tooltip__description" v-html="currentStep.description">
        </div>
      </div>
      
      <div class="guide-tooltip__footer">
        <span class="guide-tooltip__progress" v-if="showProgress">
          {{ currentIndex + 1 }}/{{ steps.length }}
        </span>
        
        <div class="guide-tooltip__buttons">
          <button 
            class="guide-btn guide-btn--prev"
            @click="prevStep"
            v-if="currentIndex > 0"
          >
            上一个
          </button>
          
          <button 
            class="guide-btn guide-btn--next"
            @click="nextStep"
          >
           {{currentIndex < steps.length - 1 ? '下一个' : '立即体验'}}
          </button>
        </div>
      </div>
      </div>
      <!-- 动态箭头元素 -->
    <div class="guide-arrow" :style="arrowStyle" ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Guide',
  props: {
    // 是否激活指引
    active: {
      type: Boolean,
      default: false
    },
    // 指引步骤配置
    steps: {
      type: Array,
      required: true,
      default: () => []
    },
    // 是否显示进度
    showProgress: {
      type: Boolean,
      default: true
    },
    // 点击遮罩层是否关闭指引
    closeOnBackdropClick: {
      type: Boolean,
      default: false
    },
    // 高亮边框样式
    highlightBorder: {
      type: Object,
      default: () => ({
        width: '2px',
        color: 'rgba(255, 255, 255, 0.8)',
        radius: '12px'
      })
    },
    // 窗口大小变化时是否自动调整位置
    autoAdjustOnResize: {
      type: Boolean,
      default: true
    },
    // 百分比宽度基于哪个维度计算 (element/window)
    percentBase: {
      type: String,
      default: 'element',
      validator: value => ['element', 'window'].includes(value)
    },
    type:{
      type:String,
      default:''
    },
    // 新增：是否允许点击高亮区域内的元素
    allowHighlightClick: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentIndex: 0,
      isActive: false,
      elementRect: null,
      position: 'bottom', // 配置的位置
      effectivePosition: 'bottom', // 实际显示的位置
      windowResizeHandler: null,
      tooltipRealWidth: 0, // 实际宽度
      tooltipRealHeight: 0, // 实际高度
      isleft:false,
      istop:false,
      resizeObserver: null, // 新增：存储ResizeObserver实例
      currentStepTop:0,//纠正错位
      shouldRender: true, // 控制指引是否渲染
    }
  },
  computed: {
    // 当前步骤
    currentStep() {
      return this.steps[this.currentIndex] || {}
    },
    // 遮罩层样式
    overlayStyle() {
      return {
        display: this.isActive ? 'block' : 'none'
      }
    },
    // 高亮边框样式
    highlightBorderStyle() {
      if (!this.elementRect) return { display: 'none' }
      
      const { top, left, width, height } = this.elementRect
      const { width: borderWidth, color, radius } = this.highlightBorder
      
      // 计算边框宽度（支持百分比）
      const computedBorderWidth = this.calculateBorderWidth(borderWidth, width, height)
      return {
        top: `${top - computedBorderWidth + (this.currentStepTop || 0)}px`,
        left: `${left - computedBorderWidth}px`,
        width: `${width + 2 * computedBorderWidth - 4}px`,
        height: `${height + 2 * computedBorderWidth - 4}px`,
        borderWidth: `${computedBorderWidth}px`,
        borderColor: color,
        borderRadius: radius,
        // 新增：确保边框不拦截鼠标事件
        pointerEvents: this.allowHighlightClick ? 'none' :'auto'
      }
    },
    // 提示框样式
    // 修改computed中的tooltipStyle，移除transform（由ensureTooltipInView统一处理）
tooltipStyle() {
  if (!this.elementRect || !this.$refs.tooltip) return { display: 'none' };
  
  const { top, left, width, height } = this.elementRect;
  const { 
    offsetX = 0, 
    offsetY = 0,
    alignment = 'center' // 默认居中
  } = this.currentStep;
  
  const tooltipStyle = {};

  switch (this.effectivePosition) {
    case 'top':
      const tooltipRect1 = this.$refs.tooltip.getBoundingClientRect();
      // 顶部位置（目标元素上方）
      tooltipStyle.top = `${top - tooltipRect1.height - 38 + offsetY}px`;
      
      switch (alignment) {
        case 'left':
          tooltipStyle.left = `${left + offsetX}px`; // 居左：与目标左侧对齐
          break;
        case 'right':
          tooltipStyle.left = `calc(${left}px + ${width}px - 100% + ${offsetX}px)`; // 居右：与目标右侧对齐
          break;
        case 'center':
        default:
          tooltipStyle.left = `${left + width/2 + offsetX}px`;
          tooltipStyle.transform = 'translateX(-50%)'; // 居中
          break;
      }
      break;
      
    case 'right':
      // 右侧位置（目标元素右侧）
      tooltipStyle.left = `${left + width + 10 + 31 + offsetX}px`;
      
      switch (alignment) {
        case 'top':
          tooltipStyle.top = `${top + offsetY}px`; // 居上：与目标顶部对齐
          break;
        case 'bottom':
          tooltipStyle.top = `calc(${top}px + ${height}px - 100% + ${offsetY}px)`; // 居下：与目标底部对齐
          break;
        case 'center':
        default:
          tooltipStyle.top = `${top + height/2 + offsetY}px`;
          tooltipStyle.transform = 'translateY(-50%)'; // 居中
          break;
      }
      break;
      
    case 'left':
      const tooltipRect2 = this.$refs.tooltip.getBoundingClientRect();
      // 左侧位置（目标元素左侧）
      tooltipStyle.left = `${left -tooltipRect2.width - 2 - 28 + offsetX}px`;
      
      switch (alignment) {
        case 'top':
          tooltipStyle.top = `${top + offsetY}px`; // 居上：与目标顶部对齐
          break;
        case 'bottom':
          tooltipStyle.top = `calc(${top}px + ${height}px - 100% + ${offsetY}px)`; // 居下：与目标底部对齐
          break;
        case 'center':
        default:
          tooltipStyle.top = `${top + height/2 + offsetY}px`;
          tooltipStyle.transform = 'translateY(-50%)'; // 居中
          break;
      }
      break;
      
    case 'bottom':
    default:
      // 底部位置（前面已实现）
      tooltipStyle.top = `${top + height + 10 + 31 + offsetY}px`;
      //console.log("======bottom",left,width);
      switch (alignment) {
        case 'left':
          tooltipStyle.left = `${left + offsetX}px`;
          break;
        case 'right':
          //tooltipStyle.left = `calc(${left}px + ${width}px - (100% + ${offsetX}px))`;
          tooltipStyle.right = `${10}px`
          break;
        case 'center':
        default:
          tooltipStyle.left = `${left + width/2 + offsetX}px`;
          tooltipStyle.transform = 'translateX(-50%)';
          break;
      }
      break;
  }
  
  return tooltipStyle;
},
arrowStyle() {
  if (!this.elementRect || !this.$refs.tooltip) return { display: 'none' };
  
  const { width: tooltipWidth, height: tooltipHeight } = this.$refs.tooltip.getBoundingClientRect();
  const { arrowOffset = 50, alignment = 'center' } = this.currentStep;
  const baseStyle = {
    position: 'absolute',
    width: '18px',
    height: '44px',
    backgroundImage: 'url(../../../../static/newStatic/img/guide/pic_yinxian@2x.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    pointerEvents: 'none'
  };
  //console.log("====img0000000",this.effectivePosition);
  switch (this.effectivePosition) {
    case 'top':
      // 顶部提示框的箭头（指向下方）
      let topArrowLeft;
      switch (alignment) {
        case 'left':
          topArrowLeft = `calc(20px + ${arrowOffset})px`; // 居左时箭头在左侧
          break;
        case 'right':
          topArrowLeft = `calc(100% - 20px)`; // 居右时箭头在右侧
          break;
        case 'center':
        default:
          topArrowLeft = '50%'; // 居中时箭头在中间
          break;
      }
      
      return {
        ...baseStyle,
        bottom: '-44px',
        left: topArrowLeft,
        transform: alignment === 'center' ? 'translateX(-50%) rotate(180deg)' : 'rotate(180deg)'
      };
      
    case 'right':
      // 右侧提示框的箭头（指向左侧）
      let rightArrowTop;
      switch (alignment) {
        case 'top':
          rightArrowTop = '20px'; // 居上时箭头在上部
          break;
        case 'bottom':
          rightArrowTop = `calc(100% - 20px)`; // 居下时箭头在下部
          break;
        case 'center':
        default:
          rightArrowTop = '50%'; // 居中时箭头在中间
          break;
      }
      
      return {
        ...baseStyle,
        left: '-31px',
        top: rightArrowTop,
        transform: alignment === 'center' ? 'translateY(-50%) rotate(270deg)' : 'rotate(270deg)'
      };
      
    case 'left':
      // 左侧提示框的箭头（指向右侧）
      let leftArrowTop;
      switch (alignment) {
        case 'top':
          leftArrowTop = '20px'; // 居上时箭头在上部
          break;
        case 'bottom':
          leftArrowTop = `calc(100% - 20px)`; // 居下时箭头在下部
          break;
        case 'center':
        default:
          leftArrowTop = '50%'; // 居中时箭头在中间
          break;
      }
      
      return {
        ...baseStyle,
        right: '-31px',
        top: leftArrowTop,
        transform: alignment === 'center' ? 'translateY(-50%) rotate(90deg)' : 'rotate(90deg)'
      };
      
    case 'bottom':
    default:
      // 底部提示框的箭头（指向上方）
      let bottomArrowLeft;
      //console.log("=====alignment",alignment);
      switch (alignment) {
        case 'left':
          bottomArrowLeft = '50px'; // 居左时箭头在左侧
          break;
        case 'right':
          bottomArrowLeft = `calc(100% - 20px - ${arrowOffset}px)`; // 居右时箭头在右侧
          break;
        case 'center':
        default:
          bottomArrowLeft = '50%'; // 居中时箭头在中间
          break;
      }
      
      return {
        ...baseStyle,
        top: '-44px',
        left: bottomArrowLeft,
        transform: alignment === 'center' ? 'translateX(-50%)' : 'none'
      };
  }
}
  },
  methods: {
    // 新增：监听目标元素尺寸变化
  watchElementResize(targetEl) {
    // 清除之前的监听（防止内存泄漏）
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    // 创建尺寸观察者
    this.resizeObserver = new ResizeObserver(entries => {
      // 当元素尺寸变化时，重新获取位置信息
      this.elementRect = this.getElementRect(targetEl);
      //console.log("====this.elementRect222222",this.elementRect);
      
      // 同步更新提示框位置（如果需要）
      this.calculateEffectivePosition(
        this.elementRect.top,
        this.elementRect.left,
        this.elementRect.width,
        this.elementRect.height
      );
      this.ensureTooltipInView();
    });
    
    // 开始监听目标元素
    this.resizeObserver.observe(targetEl);
  },
    
    // 新增：强制水平滚动到最左侧（处理页面或容器）
  scrollToLeftMost() {
    const windowWidth = window.innerWidth;
    
    const tooltipEl = this.$refs.highlight;
    const rect = tooltipEl.getBoundingClientRect();
    console.log("====999999000",windowWidth,rect,rect.left < 0,rect.left < 222,windowWidth - 222 < rect.width,this.currentIndex);
    if(rect.left < 0 || rect.left < 222 || (windowWidth - 200 < rect.width)){
      console.log("====111111111");
      document.documentElement.scrollLeft = 0;
    }
    if(rect.left + rect.width > windowWidth && this.type == 'module'){
      console.log("====2222222222",rect.left,windowWidth,document.body.scrollWidth);
      document.documentElement.scrollLeft = document.body.scrollWidth; // 将滚动条设置到最右边
    }
    if(rect.top > 700 && this.type == 'module'){
       //console.log("====3333333")
      //box-container是添加overflow的父div，也就是出现滚动条的div
      var scrollTarget = document.getElementById("app");
      //window.scrollTo(document.body.scrollWidth, scrollTarget.scrollHeight);
    }
  },
    // 禁止滚动
  // 修改禁止滚动方法
disableScroll() {
  // 保存当前滚动位置
  this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  this.scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
  // 防止滚动条消失导致页面抖动
  const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

  // 禁止页面滚动
  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';
  document.body.style.paddingRight = `${scrollBarWidth}px`;
  
  // 锁定滚动位置
  window.scrollTo({
    top: this.scrollTop,
    left: this.scrollLeft,
    behavior: 'auto'
  });

  // 阻止鼠标滚轮事件
  window.handleWheel = (e) => {
    e.preventDefault();
  };
  window.addEventListener('wheel', window.handleWheel, { passive: false });
},

// 对应的恢复滚动方法也需要调整
enableScroll() {
  // 恢复overflow属性
  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';
  document.body.style.paddingRight = '';
  
  // 移除滚轮事件监听
  window.removeEventListener('wheel', window.handleWheel, { passive: false });
  
  // 恢复滚动位置
  window.scrollTo({
    top: this.scrollTop,
    left: this.scrollLeft,
    behavior: 'auto'
  });
},
    // 计算实际显示位置（考虑窗口边界）
    calculateEffectivePosition(top, left, width, height) {
      let calculatedPosition = this.position
  const windowWidth = window.innerWidth
  const windowHeight = window.innerHeight
  // 使用动态获取的尺寸（默认值兜底）
  const tooltipWidth = this.tooltipRealWidth || 300
  const tooltipHeight = this.tooltipRealHeight || 200
  //console.log("=====是不是居右了",windowWidth,left + width);
      // 小窗口优先保证不超出右侧和底部（按钮所在区域）
  if (windowWidth < 768) { // 小窗口判定
    // 水平方向：强制限制最大宽度
    this.tooltipMaxWidth = windowWidth - 40 // 留20px边距
    // 垂直方向：优先底部显示，超出则强制上移
    if (calculatedPosition === 'bottom' && top + height + 10 + tooltipHeight > windowHeight) {
      calculatedPosition = 'top'
    } else if (calculatedPosition === 'top' && top - 10 - tooltipHeight < 0) {
      calculatedPosition = 'bottom'
    }
    
    // 水平方向：无论配置位置，右侧超出则强制左移
    if (
      (calculatedPosition === 'right' && left + width + 10 + tooltipWidth > windowWidth) ||
      (calculatedPosition === 'left' && left - 10 - tooltipWidth < 0)
    ) {
      
      calculatedPosition = windowWidth > left + width + 10 ? 'right' : 'left'
    }
  } else {
    this.tooltipMaxWidth = 500 // 恢复默认最大宽度
      // 右侧超出时强制保留右侧位置（后续由ensureTooltipInView贴边）
      if (calculatedPosition === 'right' && left + width + 10 + tooltipWidth > windowWidth) {
        calculatedPosition = 'right' // 取消自动切换到左侧
      } else if (calculatedPosition === 'bottom' && top + height + 10 + tooltipHeight > windowHeight) {
        console.log("====444444",top,height,tooltipHeight,windowHeight);
        calculatedPosition = 'top'
      } else if (calculatedPosition === 'top' && top - 10 - tooltipHeight < 0) {
        calculatedPosition = 'bottom'
      } else if (calculatedPosition === 'left' && left - 10 - tooltipWidth < 0) {
        calculatedPosition = 'right'
      }
      //console.log("=======left + width",left,width,this.currentIndex);
      if(left + width < 1000 && this.type === 'select' && this.currentIndex == 1){
        
        const dialogBody = document.querySelector('.el-dialog__body');
        if (dialogBody) {
          dialogBody.style.maxHeight = '300px'; // 自定义最大高度
          dialogBody.style.overflowY = 'auto'; // 垂直滚动
        }
        calculatedPosition = 'bottom';
      }
      if(this.currentIndex == 0 && windowWidth < 1025){
        
        document.documentElement.scrollLeft = 0;
      }
  }
      
      this.effectivePosition = calculatedPosition
    },
    // 计算边框宽度
    calculateBorderWidth(borderWidth, elementWidth, elementHeight) {
      if (typeof borderWidth !== 'string') {
        return Number(borderWidth) || 2
      }
      
      if (borderWidth.endsWith('%')) {
        const percent = parseFloat(borderWidth) / 100
        return this.percentBase === 'window' ? window.innerWidth * percent : elementWidth * percent
      }
      
      if (borderWidth.endsWith('px')) {
        return parseFloat(borderWidth)
      }
      
      return 2
    },
    // 开始指引
    start() {
      this.currentStepTop = 0;
      this.currentIndex = 0;
      window.scrollTo(0, 0);
      this.$nextTick(() => {
      this.updateCurrentStep()
      if (this.autoAdjustOnResize) {
        this.addResizeListener()
      }
      });
    },

    handleHighlightClick() {
  if (this.allowHighlightClick && this.currentStep.onClick) {
    // 执行元素的交互操作（例如点击按钮后元素高度变化）
    this.currentStep.onClick();

    // 关键：交互后强制更新尺寸（等待DOM渲染完成）
    this.$nextTick(() => {
      const targetEl = document.querySelector(this.currentStep.selector);
      if (targetEl) {
        // 重新获取元素尺寸并更新高亮区域
        this.elementRect = this.getElementRect(targetEl);
        //console.log("====this.elementRect00000",this.elementRect);
        // 同步更新提示框位置
        this.calculateEffectivePosition(
          this.elementRect.top,
          this.elementRect.left,
          this.elementRect.width,
          this.elementRect.height
        );
        this.ensureTooltipInView();
      }
    });
  }
},

    
    // 更新当前步骤
   async updateCurrentStep() {
  const step = this.currentStep;
  if (!step) return;
  

  // 强制清空旧位置信息
  if(this.type === 'select' && this.currentIndex === 0){
    this.elementRect = null;
    this.effectivePosition = 'bottom';
  }
  
  this.$nextTick(() => { // 等待当前步骤DOM更新
    const targetEl = document.querySelector(step.selector);
    if (!targetEl) return;
  
    this.elementRect = this.getElementRect(targetEl);

    // 启动尺寸监听（关键新增）
    this.watchElementResize(targetEl);


    this.position = step.position || 'bottom'; // 重置为当前步骤的配置位置
    this.scrollToTargetElement(targetEl);
    // 双重nextTick确保提示框内容渲染完成
    this.$nextTick(() => {
      //console.log("=====this.currentIndex",this.currentIndex,this.elementRect.left,this.elementRect.width,);
      if(this.type === 'select' && this.currentIndex === 2 && this.elementRect.left + this.elementRect.width < 1000){
          const scrollWrapper = document.querySelector('.el-dialog__body');
          if (scrollWrapper) {
            // 1. 设置滚动位置
            scrollWrapper.scrollTop = 300;
          }
      }
      const tooltipEl = this.$refs.highlight;
      if (tooltipEl) {
        // 强制重绘后获取真实尺寸
        tooltipEl.style.display = 'none';
        tooltipEl.offsetHeight; // 触发重绘
        tooltipEl.style.display = '';
        // 关键：更新尺寸
        this.tooltipRealWidth = tooltipEl.offsetWidth;
        this.tooltipRealHeight = tooltipEl.offsetHeight;
      }
      
      // 基于新尺寸重新计算位置
      this.calculateEffectivePosition(
        this.elementRect.top,
        this.elementRect.left,
        this.elementRect.width,
        this.elementRect.height
      );
      
      this.scrollToLeftMost();
      this.ensureTooltipInView(); // 基于新的effectivePosition调整
      
    });
    
  });
  this.$emit('step-change', this.currentIndex, step);
},
// 新增：检查元素是否完全在可视区域内
isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

  // 元素完全在视口内（上下左右都不超出）
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= viewportHeight &&
    rect.right <= viewportWidth
  );
},
// 滚动到目标元素（确保完全显示）
// scrollToTargetElement(targetEl) {
//   this.$nextTick(() => { // 确保DOM更新后再计算位置
//     // 1. 先检查元素是否已在可视区域内
//     if (this.isElementInViewport(targetEl)) {
//       return; // 已在视图中，无需滚动
//     }

//     // 2. 先滚动父容器确保可见（避免父容器滚动干扰）
//     this.scrollParentToView(targetEl);

//     // 3. 再滚动元素自身，使用nearest参数减少不必要滚动
//     this.$nextTick(() => { // 等待父容器滚动完成
//       targetEl.scrollIntoView({
//         behavior: 'smooth',
//         block: 'nearest', // 垂直方向：就近对齐（已在视图中则不滚动）
//         inline: 'nearest' // 水平方向：就近对齐
//       });
//     });
//   });
// },
// 修改 scrollToTargetElement 方法，使其将元素滚动到屏幕上下中间
scrollToTargetElement(targetEl) {
  this.$nextTick(() => {
    if (!targetEl) return;

    const rect = targetEl.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const elementCenterY = rect.top; //+ rect.height / 2; // 元素垂直中心
    const viewportCenterY = viewportHeight / 2 + 20; // 屏幕垂直中心
    const scrollOffset = elementCenterY - viewportCenterY; // 计算需要滚动的距离
    //console.log("====scrollOffset",elementCenterY , viewportCenterY,viewportHeight,rect);
    // 先滚动父容器确保可见
    this.scrollParentToView(targetEl);

    // 再滚动窗口使元素居中
    this.$nextTick(() => {
      window.scrollBy({
        top: scrollOffset,
        //behavior: 'smooth' // 平滑滚动
      });

      // 强制更新元素位置信息（确保高亮区域位置准确）
      this.elementRect = this.getElementRect(targetEl);
      this.ensureTooltipInView();
    });
  });
},

    scrollParentToView(element) {
  let parent = element.parentElement;
  while (parent) {
    // 同时检查水平和垂直方向是否可滚动
    const style = getComputedStyle(parent);
    const isVScrollable = ['auto', 'scroll'].includes(style.overflowY); // 垂直可滚动
    const isHScrollable = ['auto', 'scroll'].includes(style.overflowX); // 水平可滚动
    ////console.log("=====isHScrollable",style.overflowY,isVScrollable,isHScrollable);
    if (isVScrollable || isHScrollable) {
      // 获取元素和父容器的位置信息（相对于视口）
      const rect = element.getBoundingClientRect();
      const parentRect = parent.getBoundingClientRect();

      // 垂直方向调整（保留原有逻辑并优化）
      if (isVScrollable) {
        // 元素顶部超出父容器顶部
        if (rect.top < parentRect.top) {
          //console.log("pppppppppp",rect.top,parentRect.top);
          parent.scrollBy({
            top: rect.top - parentRect.top - 20, // 20px边距
            behavior: 'smooth'
          });
        } 
        // 元素底部超出父容器底部
        else if (rect.bottom > parentRect.bottom) {
          parent.scrollBy({
            top: rect.bottom - parentRect.bottom + 20,
            behavior: 'smooth'
          });
        }
      }
      
      // 新增：水平方向调整
      if (isHScrollable) {
        // 元素左侧超出父容器左侧
        ////console.log("======rect.left",rect.left,parentRect.left);
        ////console.log("======rect.right",rect.right,parentRect.right);
        if (rect.left < parentRect.left) {
          parent.scrollBy({
            left: rect.left - parentRect.left - 20, // 20px边距
            behavior: 'smooth'
          });
        } 
        // 元素右侧超出父容器右侧
        else if (rect.right > parentRect.right) {
          parent.scrollBy({
            left: rect.right - parentRect.right + 20,
            behavior: 'smooth'
          });
        }
      }
    }

    parent = parent.parentElement; // 继续向上查找父容器
  }
},
    // 获取元素位置信息
    
    getElementRect(element) {
      const rect = element.getBoundingClientRect()
      return {
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        bottom: rect.bottom,
        right: rect.right
      }
    },
    // 确保提示框在可视区域内（右侧超出时贴边）
    ensureTooltipInView() {
  if (!this.$refs.tooltip) return;
  
  const tooltipEl = this.$refs.tooltip;
  const rect = tooltipEl.getBoundingClientRect();
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const padding = 10;
  const { effectivePosition, alignment } = this;

  // 新增垂直方向强制校准（解决表单展开/折叠导致的偏移）
  if (rect.bottom > windowHeight - padding) {
    tooltipEl.style.top = `${windowHeight - padding - rect.height}px`;
  } else if (rect.top < padding) {
    tooltipEl.style.top = `${padding}px`;
  }

  // 水平方向检查（top/bottom）
  if (['top', 'bottom'].includes(effectivePosition)) {
    if (alignment === 'left' && rect.right > windowWidth - padding) {
      tooltipEl.style.left = `${windowWidth - padding - rect.width}px`;
    }
    if (alignment === 'right' && rect.left < padding) {
      tooltipEl.style.left = `${padding}px`;
    }
    if (alignment === 'center') {
      if (rect.right > windowWidth - padding) {
        tooltipEl.style.left = `${windowWidth - padding - rect.width/2}px`;
      }
      if (rect.left < padding) {
        tooltipEl.style.left = `${padding + rect.width/2}px`;
      }
    }
  }

  // 垂直方向检查（left/right）
  if (['left', 'right'].includes(effectivePosition)) {
    if (alignment === 'top' && rect.bottom > windowHeight - padding) {
      tooltipEl.style.top = `${windowHeight - padding - rect.height}px`;
    }
    if (alignment === 'bottom' && rect.top < padding) {
      tooltipEl.style.top = `${padding}px`;
    }
    if (alignment === 'center') {
      if (rect.bottom > windowHeight - padding) {
        tooltipEl.style.top = `${windowHeight - padding - rect.height/2}px`;
      }
      if (rect.top < padding) {
        tooltipEl.style.top = `${padding + rect.height/2}px`;
      }
    }
  }

  // 重新计算箭头位置
  this.$nextTick(() => {
    this.arrowStyle;
  });
},

// 新增：获取初始transform值（与tooltipStyle保持一致）
getInitialTransform() {
  switch (this.effectivePosition) {
    case 'top':
      return 'translate(-50%, -100%)';
    case 'right':
      return 'translateY(-50%)';
    case 'left':
      return 'translate(-100%, -50%)';
    case 'bottom':
    default:
      return 'translateX(-50%)';
  }
},
    // 窗口大小变化处理
    handleWindowResize() {
      if (this.windowResizeHandler) {
        clearTimeout(this.windowResizeHandler)
      }
      //小窗口下缩短防抖时间，确保快速响应
      this.windowResizeHandler = setTimeout(() => {
        const targetEl = document.querySelector(this.currentStep.selector)
        if (targetEl) {
          this.elementRect = this.getElementRect(targetEl)
          //console.log("====this.elementRect111111",this.elementRect);
          // 重新获取尺寸并调整
          this.$nextTick(() => {
            this.tooltipRealWidth = this.$refs.tooltip.offsetWidth || 300
            this.tooltipRealHeight = this.$refs.tooltip.offsetHeight || 200
            this.ensureTooltipInView()
          })
        }
      }, window.innerWidth < 768 ? 50 : 100) // 小窗口防抖更灵敏
    },
    // 添加 resize 监听
    addResizeListener() {
      window.addEventListener('resize', this.handleWindowResize)
      window.addEventListener('scroll', this.handleWindowResize)
    },
    // 移除 resize 监听
    removeResizeListener() {
      window.removeEventListener('resize', this.handleWindowResize)
      window.removeEventListener('scroll', this.handleWindowResize)
      if (this.windowResizeHandler) {
        clearTimeout(this.windowResizeHandler)
      }
    },
    hasHorizontalScrollbar() {
      // 页面总宽度（包括超出可视区域的部分）
      const pageTotalWidth = document.documentElement.scrollWidth;
      // 浏览器可视区域宽度
      const viewportWidth = window.innerWidth;
      // 存在水平滚动条的条件：总宽度 > 可视宽度（考虑1px误差）
      return pageTotalWidth > viewportWidth + 1;
    },
    
    // 下一步
   nextStep() {
  if (this.currentIndex < this.steps.length - 1) {
    
    // 1. 立即销毁旧指引（移除DOM）
    this.shouldRender = this.type === 'select' && this.currentIndex === 0 ? false :true;
     // 2. 等待DOM完全清空（微任务级别）
    this.$nextTick(() => {
      // 3. 更新步骤索引
      this.currentIndex++;
      this.$emit("open", this.type === 'select' && this.currentIndex === 1 ? 'next' : this.currentIndex);

      // 4. 等待弹框过渡完成（适配element弹框动画）
      const transitionDuration = this.currentStep.transitionDuration || 0;
      setTimeout(() => {
        // 5. 重建新指引
        this.shouldRender = true;
        this.$nextTick(() => {
          this.updateCurrentStep(); // 重新计算位置
          this.ensureTooltipInView();
        });
      }, transitionDuration);
    });
  } else {
    this.finish();
  }
},
    // 上一步
    prevStep() {
      if (this.currentIndex > 0) {

        //this.shouldRender = false; // 销毁旧指引
         this.$nextTick(() => {
          this.currentIndex--;
          this.$emit("open", this.type === 'select' && this.currentIndex === 0 ? 'up' : this.currentIndex);

          const transitionDuration = this.currentStep.transitionDuration || 0;
          setTimeout(() => {
            this.shouldRender = true;
            this.$nextTick(() => {
              this.updateCurrentStep();
              this.ensureTooltipInView();
            });
          }, transitionDuration);
        });
      }
    },
    // 完成指引
    finish() {
      this.enableScroll()
      this.isActive = false
      this.removeResizeListener()
      this.$emit('done', this.type);
      this.removeUrlParam("isGuide");
      window.removeEventListener('wheel', window.handleWheel, { passive: false });
      this.removePointerEventsNone();
      // 新增：断开尺寸监听
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    },
    removePointerEventsNone() {
  // 获取所有包含pointerEventsNone类名的元素
  const elements = document.querySelectorAll('[class*="pointerEventsNone"]');
  
  // 遍历并移除pointer-events样式
  elements.forEach(element => {
    element.style.pointerEvents = '';

      const elements1 = document.querySelectorAll('.el-dialog');
  
  // 遍历所有匹配元素并移除pointer-events样式
  elements1.forEach(element => {
    element.style.pointerEvents = 'auto';
  });
    
    // 可选：同时移除类名（如需完全清除标记）
    element.classList.remove('pointerEventsNone');
  });
  
  // 返回处理结果
  console.log(`已移除 ${elements.length} 个元素的pointer-events限制`);
  return elements.length;
},
    removeUrlParam(paramName) {
      // 解析当前URL
      const url = new URL(window.location.href);
      
      // 移除指定参数
      url.searchParams.delete(paramName);
      
      // 更新URL（不刷新页面）
      window.history.replaceState({}, document.title, url.href);
    },
    // 点击遮罩层
    onBackdropClick() {
      if (this.closeOnBackdropClick) {
        this.finish()
      }
    },
  },
  watch: {
    active(val) {
      this.isActive = val
      if (val) {
        this.start()
      } else {
        this.removeResizeListener()
      }
    },
    // currentIndex() {
    //   this.updateCurrentStep();
    //   this.scrollToLeftMost();
    // },
    isActive(val) {
      this.$emit(val ? 'start' : 'end')
    },
    autoAdjustOnResize(val) {
      if (val && this.isActive) {
        this.addResizeListener()
      } else {
        this.removeResizeListener()
      }
    },
    // elementRect(val){
    //   if(val.top < 64 ){
    //     window.scrollTo(0, 10);
    //   }
    //   //console.log("监听====",val);
    // }
  },
  beforeDestroy() {
    this.removeResizeListener();
    
  }
}
</script>
<style scoped lang="scss">
/* 样式保持不变，仅补充右侧箭头样式 */
.guide-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  pointer-events: none;
  opacity: 0;
  animation: fadeIn 0.1s ease forwards;
}
@keyframes fadeIn {
  to { opacity: 1; }
}
.guide-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}
.guide-backdrop-section {
  position: absolute;
  transition: all 0.3s ease;
  pointer-events: auto; /* 只有遮罩部分拦截事件 */
  z-index: 2;
}


.guide-highlight-border {
  position: absolute;
  pointer-events: none;
  border-style: solid;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.56);
  z-index: 1;
  
}
.guide-tooltip-2 {
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: auto;
  transition: all 0.3s ease;
  min-width: 320px;
  min-height: 116px;
  background: #F3F8FF;
  border-radius: 16px;
}
.guide-tooltip {
  position: absolute;
  z-index: 2;
  max-width: 90%;
  
}
.guide-tooltip__title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  span:nth-of-type(1){
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
  }
  div{
    width: 40px;
    height: 24px;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #AAAAAA;
    text-align: center;
    line-height: 24px;
    cursor: pointer;
    &:hover{
      background: rgba(0,0,0,0.04);  
    }
    &:active{
      background: rgba(0,0,0,0.08);
    }
  }
}
.guide-tooltip__content{
  margin: 16px 0 24px 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
.guide-tooltip__description {
  margin: 0 0 16px 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 22px;
}
.guide-tooltip__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.guide-tooltip__progress {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #333333;
}
.guide-tooltip__buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.guide-btn {
  border-radius: 4px;
  border: none;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.guide-btn--prev {
  width: 72px;
  height: 28px;
  background: rgba(255,255,255,0);
  border-radius: 8px;
  border: 1px solid #7097D8;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #0046B9;
  &:hover{
    background: rgba(0,71,185,0.04);
  }
  &:active{
    background: rgba(0,70,185,0.08);
  }
}
.guide-btn--next {
  width: 72px;
  height: 28px;
  background: linear-gradient( 270deg, #4B58E5 0%, #206DEA 100%);
  border-radius: 8px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 13px;
  color: #FFFFFF;
  &:hover{
    background: linear-gradient( 270deg, #6772E9 0%, #4384ED 100%);
  }
  &:active{
    background: linear-gradient( 270deg, #3853DA 0%, #1862DE 100%);
  }
}
.guide-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.guide-arrow {
  pointer-events: none; // 避免箭头拦截点击事件
  
}
/* 提示框箭头样式优化 */
// .guide-tooltip--top::after {
//   content: '';
//   position: absolute;
//   bottom: -44px;
//   left: 50%;
//   transform: translateX(-50%) rotate(180deg);
//   width: 18px;
//   height: 44px;
//   background-image: url('../../../../static/newStatic/img/guide/pic_yinxian@2x.png');
//   background-size: cover;
//   background-position: center;
// }
// .guide-tooltip--bottom::after {
//   content: '';
//   position: absolute;
//   top: -44px;
//   left: 50%;
//   transform: translateX(-50%);
//   width: 18px;
//   height: 44px;
//   background-image: url('../../../../static/newStatic/img/guide/pic_yinxian@2x.png');
//   background-size: cover;
//   background-position: center;
// }
// .guide-tooltip--left::after {
//   content: '';
//   position: absolute;
//   top: 50%;
//   right: -31px;
//   transform: translateY(-50%) rotate(90deg);
//   width: 18px;
//   height: 44px;
//   background-image: url('../../../../static/newStatic/img/guide/pic_yinxian@2x.png');
//   background-size: cover;
//   background-position: center;
// }
// .guide-tooltip--right::after {
//   content: '';
//   position: absolute;
//   top: 50%;
//   left: -31px; /* 贴边时箭头位置调整 */
//   transform: translateY(-50%) rotate(270deg);
//   width: 18px;
//   height: 44px;
//   background-image: url('../../../../static/newStatic/img/guide/pic_yinxian@2x.png');
//   background-size: cover;
//   background-position: center;
// } 
/* 响应式调整 */
@media (max-width: 768px) {
  .guide-tooltip {
    max-width: 90% !important; /* 强制限制宽度 */
    min-width: auto !important; /* 取消最小宽度限制 */
    padding: 12px !important;
  }

  .guide-tooltip-2 {
    min-height: auto !important; /* 高度随内容变化 */
  }

  .guide-tooltip__footer {
    flex-direction: column-reverse; /* 按钮居下，进度在上 */
    align-items: stretch !important;
  }

  .guide-tooltip__buttons {
    width: 100% !important;
    justify-content: space-between; /* 按钮占满宽度 */
  }

  .guide-btn {
    width: 48% !important; /* 按钮平分宽度 */
  }
}
</style>


// WEBPACK FOOTER //
// src/components/backstageManagement/guide/guide.vue